import { useDisclosure } from '@shared/hooks';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate, useSearchParams, generatePath } from 'react-router-dom';

import { PATHS } from '../../../..';
import { Alert, Button } from '../../../../../components';
import { ExamSubmissionConfirmationModal } from '../../../../exam/components';

export default function ExamReviewFooter() {
  const { t } = useTranslation();
  const { taskId } = useParams();
  const navigate = useNavigate();

  const [isExamSubmissionConfirmationOpen, { toggle }] = useDisclosure(false);

  const [searchParams, setSearchParams] = useSearchParams({});

  const handleBackToExam = () => {
    const q = searchParams.get('q') ?? '';
    const params = new URLSearchParams();
    params.set('q', q);
    params.set('page', 'exam');

    const query = params.toString();
    setSearchParams(query);
  };

  const submitExamPaper = async () => {
    navigate(generatePath(PATHS.Preview.Completed, { taskId }), {
      state: true,
    });
  };

  return (
    <div className='mt-1 flex flex-none flex-col items-center gap-6'>
      {/* TODO: SET eExam - this should be 472px to match the others */}
      <Alert
        className='w-[478px] text-start'
        variant='warning'
        message={t('examReviewFooter.alert')}
      />
      <div className='flex justify-center gap-4'>
        <Button variant='outlined' className='min-w-[232px]' onClick={handleBackToExam}>
          {t('examReviewFooter.backToExam')}
        </Button>
        <Button className='min-w-[232px]' onClick={toggle}>
          {t('examReviewFooter.button')}
        </Button>
      </div>
      <ExamSubmissionConfirmationModal
        open={isExamSubmissionConfirmationOpen}
        onClose={toggle}
        onSubmitExam={submitExamPaper}
        submitting={false}
      />
    </div>
  );
}
